import Vue from 'vue'
import api from '@/api'
import status from '@/utils/status'
import format from '@/utils/format'
import options from '@/utils/options'
import _ from 'lodash';

function hasDisposalData(disposal, detail) {
	if (detail?.projectCategory !== 'DISPOSAL') return false
	const name = disposal?.disposalName && String(disposal.disposalName).trim()
	return !!(disposal?.disposalId || name)
}

const state = {
	info: {
		client: {},
		code: '',
		detail: {},
		fileList: [],
		summary: {},
		title: '',
		upperProject: {}
	},
	summary: [],
	detail: [],
	client: [],
	disposal: {},
	form: {
		client : {
			id: "",
			name: "",
			parentClient: {
				id : "",
				name : ""
			},
			bizNum: "",
			ceoName: "",
			contact: {
				phone : "",
				fax : ""
			},
			address: "",
			addressDetail: "",
			memo: "",
			managers: []
		},
		disposal: {
			id: "",
			name: "",
			parentClient: {
				id: "",
				name: ""
			},
			bizNum: "",
			ceoName: "",
			contact: {
				phone: "",
				fax: ""
			},
			address: "",
			addressDetail: "",
			memo: ""
		},
		project : {
			code : "",
			requestDate: "",
			completeDate: "",
			dept: {
				id : "",
				name : ""
			},
			user: {
				id : "",
				name : ""
			},
			type: {
				value : "",
				text : ""
			},
			useFor: {
				value : "",
				text : ""
			},
			analysisDept: {
				id : "",
				name : ""
			},
			amount: "",
			sampleName: "",
			sampleDeliveryWay: "",
			sampleCount: "",
			description: "",
			address : "",
			addressDetail :"",
			title : "",
			storageMaterial: "",
			parentProject: { 
				id: '', 
				text: ''
			},
			backfill: "N",
			engineer: "",
		}
	},
	files: [],
	specimenFileList : [],
	autoOptions: {
		sampleName: [],
	},
	autoCode: ''
}

const getters = {
	info: state => {
		return state.info
	},
	//해당 상태 완료를 기준으로 수정 버튼 활성화 여부
	isStatusComplete: state => state.info.detail.status === 'WORK_COMPLETE',
	files: state => state.files,
	summary: state => {
		let list = []
		let keys = Object.keys(state.summary);
		keys.forEach(key => {
			list.push({
				key: key,
				name: status.project_detail.summary[key],
				value: format.dataValue(key, state.summary),
				color: status.color[state.summary[key]] ?? 'black',
			})
		})
		list.push({
			key: 'upperClient',
			name: '상위 업무 번호',
			value: state.info.parentProject?.code ? state.info.parentProject.code : '',
			type: 'link',
			id: state.info.parentProject?.id ? state.info.parentProject?.id : ''
		})
		return list;
	},
	detail: state => {
		let list = []
		//20240813 토양일 때에는 되메움토 발생지 필드 추가 필요. 타입값을 몰라 부서명에서 토양 타입 여부 판별
		let fieldList = [];
		if(state.info?.detail?.projectAnalysisDept?.indexOf('토양') >= 0) {
			fieldList = status.project_detail.soil_detail
		} else if(state.info?.detail?.projectCategory === 'DISPOSAL') {
			fieldList = status.project_detail.disposal_detail;
		} else {
			fieldList = status.project_detail.detail
		}
		fieldList.forEach(item => {
			list.push({
				key: item.key,
				name: item.key === 'projectAddress' && state.detail.projectBackfill === 'Y' ? '되메움토발생지' : item.name,
				value: format.dataValue(item.key, state.detail),
				type: item.type
			})
		})
		list.unshift({
			key: 'parentProject',
			name: '상위 업무 번호',
			value: state.info.parentProject?.id ? state.info.parentProject.id : ''
		})
		return list;
	},
	client: state => {
		let list = []
		status.project_detail.client.forEach(item => {
			let value
			if (item.key === 'clientAddress') {
				value = [state.client.clientAddress, state.client.clientAddressDetail]
					.filter(Boolean)
					.join(' ') || '-'
			} else {
				value = format.dataValue(item.key, state.client)
			}
			list.push({
				key: item.key,
				name: item.name,
				value,
				type: item.type
			})
		})
		return list;
	},
	disposal: state => {
		if (!hasDisposalData(state.disposal, state.info?.detail)) return []
		let list = []
		status.project_detail.disposal.forEach(item => {
			if (item.key === 'parentClientName') {
				const parent = state.disposal.parentClient
				const hasParent =
					parent?.id || (parent?.name && String(parent.name).trim())
				if (!hasParent) return
			}
			let value
			if (item.key === 'disposalAddress') {
				value = [state.disposal.disposalAddress, state.disposal.disposalAddressDetail]
					.filter(Boolean)
					.join(' ') || '-'
			} else if (item.key === 'parentClientName') {
				value = state.disposal.parentClient?.name?.trim() || '-'
			} else if (item.key === 'disposalCode') {
				value = state.disposal.disposalCode || state.disposal.disposalId || '-'
			} else {
				value = format.dataValue(item.key, state.disposal)
			}
			list.push({
				key: item.key,
				name: item.name,
				value,
				type: item.type
			})
		})
		return list;
	},
	form: state => state.form,
	autoOptions: state => state.autoOptions,
	autoCode: state => state.autoCode
}

const mutations = {
	setInfo: (state, data) => {
		state.info = {...state.info , ...data}
		state.summary = {...data.summary}
		state.detail = {...data.detail}
		state.client = {...data.client}
		state.disposal = data.disposal ? { ...data.disposal } : {}
	},
	setFile: (state, data) => {
		if(data)
			state.files = [...state.files, ...data]
	},
	resetForm: (state) => {
		state.form = {...state.form}
		const cKeys = Object.keys(state.form.client)
		let client = {};
		cKeys.forEach(key => {
			if(Array.isArray(state.form.client[key])) {
				client[key] = []
			} else if(key === 'contact') {
				client[key] = { phone: '', fax: '' }
			} else if(typeof state.form.client[key] == 'object') {
				client[key] = {id: '', name: ''}
			} else {
				client[key] = ''
			}
		})
		const dKeys = Object.keys(state.form.disposal)
		let disposal = {};
		dKeys.forEach(key => {
			if(key === 'contact') {
				disposal[key] = { phone: '', fax: '' }
			} else if(typeof state.form.disposal[key] === 'object') {
				disposal[key] = { id: '', name: '' }
			} else {
				disposal[key] = ''
			}
		})
		const pKeys = Object.keys(state.form.project)
		let project = {};
		pKeys.forEach(key => {
			project[key] = ''
			if(typeof state.form.project[key] === 'object') {
				project[key] = {id: '', name: '', text: ''}
			}
			if(key === 'backfill') {
				project[key] = ''
			}
		})
		state.form = {client: client, disposal: disposal, project: project}

		// 되메움토 발생 초기화
		state.form.project.backfill = "N"
	},
	setForm: (state, data) => {
		if(!data) return;
		const mappings = [
			['client.name', 'client.clientName'],
			['client.id', 'client.clientId'],
			['client.contact.phone', 'client.clientPhone', v => format.phone(v)],
			['client.contact.fax', 'client.clientFax'],
			['client.memo', 'client.clientMemo'],
			['client.bizNum', 'client.clientBizNum'],
			['client.ceoName', 'client.clientCeoName'],
			['client.address', 'client.clientAddress'],
			['client.addressDetail', 'client.clientAddressDetail'],
			['client.managers', 'client.managers'],
			['client.manager', 'client.managers', v => v.map(el => el.id)],
		
			['project.code', 'code'],
			['project.title', 'title'],
			['project.parentProject.text', 'parentProject.code'],
			['project.parentProject.id', 'parentProject.id'],
			['project.type.text', 'detail.projectType'],
			['project.type.value', 'detail.projectType'],
			['project.completeDate', 'detail.projectDueDate'],
			['project.requestDate', 'detail.projectRequestDate'],
			['project.useFor.text', 'detail.projectUseFor'],
			['project.useFor.value', 'detail.projectUseFor'],
			['project.user.name', 'detail.projectUser'],
			['project.dept.name', 'detail.projectDept'],
			['project.analysisDept.name', 'detail.projectAnalysisDept'],
			['project.sampleDeliveryWay', 'detail.projectSampleDeliveryWay'],
			['project.description', 'detail.projectDescription'],
			['project.address', 'detail.projectAddress'],
			['project.backfill', 'detail.projectBackfill'],
			['project.amount', 'detail.projectAmount'],
			['project.storageMaterial', 'detail.projectStorageMaterial'],
			['project.category', 'detail.projectCategory'],
			['project.engineer', 'detail.engineer']
		];
		const detail = _.cloneDeep(state.form);

		mappings.forEach(([to, from, formatter]) => {
			const value = _.get(data, from);
			_.set(detail, to, formatter ? formatter(value) : (value ?? ''));
		});

		const disposal = data.disposal || {};
		const detailFields = data.detail || {};
		detail.disposal = {
			id: disposal.disposalId ?? '',
			name: disposal.disposalName || detailFields.projectDisposalName || '',
			parentClient: disposal.parentClient || { id: '', name: '' },
			bizNum: disposal.disposalBizNum || detailFields.projectDisposalBizNum || '',
			ceoName: disposal.disposalCeoName || detailFields.projectDisposalCeoName || '',
			contact: {
				phone: format.phone(disposal.disposalPhone || detailFields.projectDisposalPhone || ''),
				fax: disposal.disposalFax || detailFields.projectDisposalFax || ''
			},
			address: disposal.disposalAddress || detailFields.projectDisposalAddress || '',
			addressDetail: disposal.disposalAddressDetail || detailFields.projectDisposalAddressDetail || '',
			memo: disposal.disposalMemo || detailFields.projectDisposalMemo || ''
		};

		state.form = detail;
	},
	setAutoCompleteOptions: (state, obj) => {
		// autoOptions 에는 sampleName 키만 미리 있다. sampleContainer 처럼
		// 나중에 생기는 키를 평범한 대입으로 넣으면 Vue 2 가 추적하지 못해
		// 값은 들어가도 화면이 알림을 못 받는다. 템플릿이 직접 읽던 시절에는
		// 다른 이유로 다시 그려질 때 우연히 반영됐지만, computed 로 감싸면
		// 캐시가 영영 풀리지 않아 첫 계산값에 고정된다(시료 용기 하드코딩 5개).
		Vue.set(state.autoOptions, obj.key, [...obj.list.map(el => {
			return {
				text: el,
				value: el
			}
		})])
	},
	setAutoCode: (state, data) => {
		state.autoCode = data;
	}
}

const actions = {
	loadInfo: async ({state, commit}, id) => {
		const res = await api.project.getInfo(id)
		commit('setInfo', res)
		commit('resetForm')
		commit('setForm', res)
	},
	add: async ({state, commit}, body) => {
		const res = await api.project.add(body)
		return res;
	},
	edit: async ({state, commit}, payload) => {
		const {id, body} = payload
		const res = await api.project.update(id, body)
		return res;
	},
	updateStatus: async ({state, dispatch}, payload) => {
		const {id, body} = payload
		const res = await api.project.updateStatus(id, body)
		dispatch('loadInfo', id)
		return res;
	},
	loadFile: async ({state, commit}, id) => {
		const res = await api.project.getFile(id);
		commit('setFile', res)
	},
	addFile: async({state, commit}, {id, body}) => {
		const res = await api.project.addFile(id, body)
		return res
	},
	deleteFile: async({state, commit}, id) => {
		const res = await api.project.deleteFile(id)
		return res;
	},
	//업무 생성 / 수정시 리스트 자동완성
	loadAutoComplete: async ({state, commit}, {key, projectId}) => {
		const res = await api.project.loadAutoComplete(key, projectId) 
		commit('setAutoCompleteOptions', {list: res.list, key: key})
	},
	//업무 생성 / 수정 시 자동 문서번호 생성
	loadAutoCode: async ({state, commit}, payload) => {
		const res = await api.project.loadAutoNum(payload)
		commit('setAutoCode', res?.code)
		return res?.code;
	},
	//업무 삭제
	deleteProject: async({state, dispatch}, id) => {
		const res = await api.project.deleteProject(id)
		dispatch('loadInfo', id);
		return res;
	}
}

export default { namespaced: true, state, getters, mutations, actions }